/** The file fields that hold where a file came from (agent-5-5). */
export const FILE_SOURCE_PROVIDER_FIELD = "data_source_provider";
export const FILE_SOURCE_NAME_FIELD = "data_source_name";
